export const initialState = () => ({
  additives: [],
  accession: {},
  discount_type: "",
  discount: "",
  contract_type: {},
  shipping: "",
  shippingName: "",
  dueDate: "",
  payment: "",
  uuid: "",
  contractExternalId: 0,
  personExternalId: 0,
  contractAddress: {},
  paymentTypesOptions: [],
  shippingMethodsOptions: [],
  serviceOrigin: null,
  dueDaysOptions: [
    { text: "Selecione...", value: 0 }
  ],
})
